var cube = require('./cube');

cube.URI = require('./uri');
if (typeof window !== 'undefined') {
  cube.Request = require('./request');
  cube.Browser = require('./browser');
  require('./cube-browser.js');
}

module.exports = cube;



//////////////////
// WEBPACK FOOTER
// ./src/js/~/cube-js.js
// module id = 34
// module chunks = 1